import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';


const bounce = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
`;

export const ScrollContainer = styled.div`
  /* Perto da borda de baixo, para abrir espaço até o texto do banner. A
     centralização é por margem: o translateX era sobrescrito pela animação de
     pulo, e o ícone ficava meia largura fora do centro. */
  position: absolute;
  bottom: 0.875rem;
  left: 50%;
  margin-left: -11px;
  animation: ${bounce} 2s infinite;
`;

export const MouseShape = styled.div`
  width: 22px;
  height: 34px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-radius: 9999px;
  display: flex;
  justify-content: center;
`;

export const Wheel = styled.div`
  width: 4px;
  height: 10px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 9999px;
  margin-top: 7px;
  animation: ${pulse} 1.5s infinite;
`;
